import { render, staticRenderFns } from "./PastGuests.vue?vue&type=template&id=5707c360&scoped=true"
import script from "./PastGuests.vue?vue&type=script&lang=js"
export * from "./PastGuests.vue?vue&type=script&lang=js"
import style0 from "./PastGuests.vue?vue&type=style&index=0&id=5707c360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707c360",
  null
  
)

export default component.exports